module.exports = __webpack_public_path__ + "img/armenia.cbf536b1.svg";